<div class="modal-header">
  <h5 class="modal-title">{{ header }}</h5>
</div>
<div class="modal-body">

  <div class="col text-center" style="margin-bottom: -20px">
    

    <button class="btn btn-outline-success" 
      style="width: 100px; margin-right: 25px; margin-bottom: 10px;" (click)="submitClick()">
      No
    </button>
  </div>
</div>